<template>
  <section class="bg">
    <div class="main-content-title" style="margin: 0 24px">Projects</div>
    <!-- <div
      class="container mb"
      v-if="consultantGigs && consultantGigs.length > 0"
    >
      <div class="row-container">
        <div class="width-container">
          <div class="title-wrapper">
            <div class="title">Your Projects</div>
          </div>
          <div v-for="gig in consultantGigs" :key="gig.id">
            <a class="item" @click="clickItem(gig.projectId, gig.roleId)">
              <div class="content">{{ gig.title }}</div>
              <div class="content-change col-25">{{ gig.workType }}</div>
              <div class="content-change col-25">{{ gig.location }}</div>
              <div class="content-change col-25 flex-center">
                <div
                  class="status"
                  :class="
                    gig.status === 'Active'
                      ? 'active'
                      : role.status === 'Inactive'
                      ? 'inactive'
                      : ''
                  "
                  v-if="gig.status"
                >
                  {{ gig.status }}
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row-container">
        <div class="width-container">
          <div class="title-wrapper">
            <div class="title">Position</div>
            <div class="title col-25">Type</div>
            <div class="title col-25">Location</div>
            <div class="title col-25" v-if="consultantId">Status</div>
          </div>
          <div v-if="consultantId && consultant">
            <div v-for="gig in showGigs" :key="gig.id">
              <div v-for="role in gig.roles" :key="role.id">
                <a
                  class="item"
                  v-if="
                    (!role.hidden &&
                      (role.work_type === 'remote' ||
                        role.location === consultant.metro) &&
                      (!role.tech_level ||
                        role.tech_level.indexOf(consultant.tech_level) > -1)) ||
                    role.show
                  "
                  @click="clickItem(gig.id, role.id)"
                >
                  <div class="content">{{ role.title }}</div>
                  <div class="content-change col-25">{{ role.work_type }}</div>
                  <div class="content-change col-25">{{ role.location }}</div>
                  <div
                    class="content-change col-25 flex-center"
                    v-if="consultantId"
                  >
                    <div
                      class="status"
                      :class="
                        role.status === 'Open'
                          ? 'open'
                          : role.status === 'Inactive'
                          ? 'inactive'
                          : role.status === 'Applied'
                          ? 'applied'
                          : ''
                      "
                      v-if="role.status"
                    >
                      {{ role.status }}
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="table-wrapper">
      <ag-grid-vue
        style="width: 100%; height: 300px"
        class="ag-theme-material"
        :gridOptions="showGigsGridOptions"
        :columnDefs="showGigsColumnDefs"
        @column-resized="onColumnResized"
        @first-data-rendered="onFirstDataRendered"
        @grid-size-changed="onFirstDataRendered"
        :rowData="showRoles"
      ></ag-grid-vue>
    </div>
  </section>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import GridTitle from "@/components/consultant/consultantProject/GridTitle.vue";

const getProjectStates = (phase) => {
  if (!phase) return "";
  if (phase.indexOf("Active") > -1) {
    return "Open";
  } else {
    return "Inactive";
  }
};

const getConsultantProjectStates = (phase) => {
  if (!phase) return "";
  if (phase.indexOf("Active") > -1) {
    return "Active";
  } else {
    return "Inactive";
  }
};

export default {
  props: ["controled", "consultantId", "companyId", "consultant", "gigs"],
  data() {
    return {
      publicGigs: [],
      showGigs: [],
      consultantGigs: [],
      showRoles: [],
      consultantGigsGridOptions: {},
      showGigsGridOptions: {},
      consultantGigsColumnDefs: null,
      showGigsColumnDefs: null,
    };
  },
  components: {
    AgGridVue,
    GridTitle,
  },
  watch: {
    gigs() {
      this.initPublicGig();
    },
    consultant() {
      this.initPublicGig();
    },
  },
  beforeMount() {
    this.initColumnDefs();
  },
  mounted() {
    this.initPublicGig();
  },
  methods: {
    initColumnDefs: function () {
      this.consultantGigsGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.consultantGigsColumnDefs = [
        { headerName: "POSITION", field: "title" },
      ];
      this.showGigsGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.showGigsColumnDefs = [
        {
          headerName: "POSITION",
          field: "title",
          cellRendererFramework: "GridTitle",
        },
        { headerName: "TYPE", field: "work_type" },
        { headerName: "LOCATION", field: "location" },
        { headerName: "STATUS", field: "status" },
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    clickItem: function (data) {
      this.$emit("clickItem", data.projectId, data.roleId);
    },
    initPublicGig: function () {
      this.publicGigs = (this.gigs || []).filter(
        (item) => item.public === "true"
      );
      if (this.companyId) {
        this.showGigs = this.publicGigs.filter(
          (item) => item.company === this.companyId
        );
      } else if (this.consultantId) {
        this.consultantGigs = [];
        this.publicGigs.forEach((project, index) => {
          const status = getProjectStates(project.phase);
          const roles = project.roles;
          const consultants = project.selected_consultants;
          if (roles && consultants && Array.isArray(consultants)) {
            roles.forEach((role, index) => {
              const id = role.id;
              role.status = status;
              const roleConsultants = consultants.find(
                (consultant, index) => consultant.role_id === id
              );
              if (roleConsultants) {
                const c = roleConsultants.consultants;
                if (
                  c &&
                  c.find(
                    (cItem) =>
                      cItem.id === this.consultantId && cItem.client_confirm
                  )
                ) {
                  this.consultantGigs.push({
                    projectId: project.id,
                    roleId: role.id,
                    title: role.title,
                    workType: role.work_type,
                    location: role.location,
                    status: getConsultantProjectStates(project.phase),
                  });
                  role.hidden = true;
                } else if (
                  c &&
                  c.find(
                    (cItem) =>
                      cItem.id === this.consultantId && cItem.reply === "yes"
                  )
                ) {
                  role.status = "Applied";
                } else if (
                  c &&
                  c.find((cItem) => cItem.id === this.consultantId)
                ) {
                  role.show = true;
                }
              }
            });
          }
        });
        if (this.consultantGigs) {
          this.consultantGigs.sort((a, b) => {
            return b.created - a.created;
          });
        }
        this.showGigs = this.publicGigs;
      } else {
        this.showGigs = this.publicGigs;
      }
      this.showGigs.sort((a, b) => {
        return b.created - a.created;
      });
      this.showRoles = [];
      this.showGigs.forEach((gig) => {
        const roles = gig.roles;
        if (roles) {
          roles.forEach((role) => {
            if (
              (!role.hidden &&
                (role.work_type === "remote" ||
                  role.location === this.consultant.metro) &&
                (!role.tech_level ||
                  role.tech_level.indexOf(this.consultant.tech_level) > -1)) ||
              role.show
            ) {
              this.showRoles.push({
                title: role.title,
                work_type: role.work_type,
                location: role.location,
                status: getConsultantProjectStates(gig.phase),
                roleId: role.id,
                projectId: gig.id,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.bg {
  background: #fff;
  font-size: 16px;
  font-family: "Avenir Next", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  padding: 7.5em 0 0;
  box-sizing: border-box;
  min-height: 100vh;
}
.bg * {
  box-sizing: border-box;
}
.mb {
  margin-bottom: 40px;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.container {
  padding-right: 12px;
  padding-left: 12px;
  margin-right: auto;
  margin-left: auto;
}
.row-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-right: -12px;
  margin-left: -12px;
}
.width-container {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}
.title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1em;
  margin-bottom: 1.5em;
  margin-right: -12px;
  margin-left: -12px;
}
.col-25 {
  flex: 0 0 25%;
  max-width: 25%;
}
.title {
  font-weight: 700;
  font-size: 1.25em;
  color: #2c3038;
  padding: 0 12px;
  flex-grow: 1;
}
.item {
  display: block;
  border: 1px solid #eaedf2;
  border-radius: 0.3125em;
  padding: 24px 16px;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background: #fff;
}
.item:hover {
  box-shadow: 0 0.5em 1em rgb(0 0 0 / 9%);
  transform: translateY(-0.5em);
}
.content {
  font-weight: 600;
  color: #2c3038;
  padding: 0 12px;
  flex-grow: 1;
}
.content-change {
  font-weight: 600;
  color: #555a64;
  padding: 0 12px;
}
.item:hover .content-change {
  color: #1a73e8;
}
.status {
  color: #fff;
  background: #009b72;
  padding: 0.5rem 0.75rem;
  border-radius: 10rem;
  display: inline;
  white-space: nowrap;
}
.applied {
  color: #2c3038;
  background: #ffc107;
}
.open {
  background: #17a2b8;
}
.inactive {
  color: #2c3038;
  background: #eaedf2;
}
@media screen and (max-width: 992px) {
  .bg {
    padding: 6em 0 0;
  }
  .width-container {
    flex: 0 0 75%;
    max-width: 75%;
  }
}
@media screen and (max-width: 768px) {
  .bg {
    padding: 3.75em 0 0;
  }
  .width-container {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  .title-wrapper {
    display: none;
  }
  .col-25 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media screen and (max-width: 576px) {
  .width-container {
    padding: 0 12px;
    flex: 0 0 100%;
    max-width: 100%;
  }
  .item {
    flex-direction: column;
  }
  .content-change {
    padding: 2.5px 12px;
  }
}
@media screen and (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media screen and (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media screen and (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.table-wrapper {
  margin: 24px;
}
</style>
